// extracted by mini-css-extract-plugin
export var pageContainer = "styles-module--pageContainer--MAtS7";
export var pageContent = "styles-module--pageContent--JyYr1";